import React from 'react';
import Helmet from "react-helmet";

class Seo extends React.Component{

    render(){
     var info = this.props.detail;
     var title = info.offerName + " - playo";
     var url = "https://playo.co/offers-and-coupons/"+info.activeKey;

     var description = info.shareMsg;
     var image = "https://d2hfzg3ugxeze1.cloudfront.net/venues-listing/venue_fallback.png";
     if(info.imageUrl){
          image = info.imageUrl;

     }

      return (
        <span>
          <Helmet
                    htmlAttributes={{lang: "en", amp: undefined}} // amp takes no value
                    title={title}
                    titleAttributes={{itemprop: "name", lang: "en"}}
                    meta={[
                        {name: "description", content: description},
                        {name : "twitter:card", content: "summary_large_image"},
                        {name:  "twitter:site" , content: "@playoApp"},
                        {name : "twitter:url" , content : url},
                        {name : "twitter:title", content : title},
                        {name : "twitter:description", content : description},
                        {name : "twitter:image" , content : image},
                        {property: "fb:app_id" ,content: "1517806818505951" },
                        {property:"og:title" , content:  title },
                        {property:"og:type" , content:  "place" },
                        {property:"og:url" , content:   url },
                        {property:"og:image" , content:  image },
                        {property:"og:description" , content: description },
                        {property:"place:location:latitude",  content:  info.lat},
                        {property:"place:location:longitude", content:  info.lng}

                    ]}
                    script={[ {type: "application/ld+json", innerHTML: ` {
                                                "@context": "https://schema.org",
                                                "@type": "LocalBusiness",
                                                "address": {
                                                  "@type": "PostalAddress",
                                                  "addressLocality": "${info.city}",
                                                  "addressRegion": "${info.city}",
                                                  "streetAddress": "${info.city}"
                                                },
                                                "description": "${description}",
                                                "name": "${info.offerName}",
                                                "image" : "${image}"
                                              }`}
                    ]}

                />
        </span>
      )
    }

}

export default Seo;



// WEBPACK FOOTER //
// ./src/components/Offer-detail-page/seoPage.js